import { IOnboardingArticle } from "src/api/server/wf-detail.types";
import { MediaContentCard } from "../ad/media-content-card";

const ONBOARDING_CARD_TEST_ID = "onboarding-article";
/**
 * PromoCard component displays promotional content with image, title, description and call-to-action
 */
export const PromoCard = ({ title, description, link, image }: IOnboardingArticle) => {
    return (
        <MediaContentCard
            title={title}
            description={description}
            containerSx={{ width: ["auto", "400px", "auto"] }}
            link={link}
            image={image}
            testId={ONBOARDING_CARD_TEST_ID}
            srcSet={[
                { queryParams: { w: 246, h: 138, fit: "crop" } },
                { queryParams: { w: 368, h: 207, fit: "crop" } },
                { queryParams: { w: 700, h: 420, fit: "crop" } },
            ]}
        />
    );
};
